import React, { Component } from "react";
import { formatNumber, isValidNumber } from "libphonenumber-js";
import { injectIntl } from "react-intl";
import { Input, Icon } from "antd";
import PropTypes from "prop-types";

// intlPhone component create the internatinal formated phone number;
class intlPhone extends Component {
  static propTypes = {
    //render icon in input
    icons: PropTypes.bool,
  };
  
  /**
   * Handling react onChange event. Adds '+' before the number and formates it,
   * then call onChange function from antd module with that number.
   * @param ReactEvent{Object}
   * @private
   */
  handleInput = ({ target }) => {
    const number = formatNumber(
      "+" + target.value.replace(/\+/g, ""),
      "International"
    );
    let parsedNumber = []
    if(isValidNumber(number)) {
      parsedNumber = number.split(' ')
      // Mark up the phone number with mask +_(___)-___-__-__
      this.props.onChange([`${parsedNumber.shift()}(${parsedNumber.shift()})`, ...parsedNumber].join('-'))
    } else
    this.props.onChange(number);
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { icons } = this.props;
    const inputProps = { ...this.props, icons: "" };
    return (
      <div>
        <Input
          {...inputProps}
          type="text"
          onChange={this.handleInput}
          suffix={icons ? <Icon type="phone" style={{ fontSize: 13 }} /> : ""}
          placeholder={
            icons
              ? formatMessage({
                  id: "register.phone-placeholder",
                  defaultMessage: "Phone number"
                })
              : "+7"
          }
        />
      </div>
    );
  }
}

export default injectIntl(intlPhone);



// WEBPACK FOOTER //
// ./src/components/utils/intlPhone.js